const context = require.context('./', true, /.jpg/i);

const images = [];
context.keys().forEach((key) => {
  images.push(context(key).default);
});

export default images;
